import { render, staticRenderFns } from "./newlocation.vue?vue&type=template&id=882cf124&scoped=true"
import script from "./newlocation.vue?vue&type=script&lang=js"
export * from "./newlocation.vue?vue&type=script&lang=js"
import style0 from "./newlocation.vue?vue&type=style&index=0&id=882cf124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882cf124",
  null
  
)

export default component.exports